"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commonData = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxAct = require("redux-act");

var _utils = require("@alycecom/utils");

var R = _interopRequireWildcard(require("ramda"));

var _commonData = require("./commonData.constants");

var actions = _interopRequireWildcard(require("./commonData.actions"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  countries: [],
  countriesMap: {},
  availableCountriesIds: [],
  emailCharsLimit: 1000,
  isLoading: false,
  isLoaded: false,
  customFields: [],
  governments: {},
  printingFeeValue: 0,
  exchangeMarketplaceThreshold: 0
};
exports.initialState = initialState;

var transformUsaStates = function transformUsaStates(states) {
  return states.map(function (_ref) {
    var name = _ref.name,
        abbr = _ref.code;
    return {
      name,
      abbr
    };
  });
};

var fillGovernments = function fillGovernments(countries, states) {
  return countries.reduce(function (acc, country) {
    if (country.id === _commonData.COUNTRY_USA_ID) {
      return _objectSpread(_objectSpread({}, acc), {}, {
        [_commonData.COUNTRY_USA_ID]: transformUsaStates(states)
      });
    }

    if (country.id === _commonData.COUNTRY_CANADA_ID) {
      return _objectSpread(_objectSpread({}, acc), {}, {
        [_commonData.COUNTRY_CANADA_ID]: _commonData.CANADA_PROVINCES
      });
    }

    return _objectSpread(_objectSpread({}, acc), {}, {
      [country.id]: []
    });
  }, {});
};

var commonData = (0, _reduxAct.createReducer)({}, initialState);
exports.commonData = commonData;
commonData.on(actions.commonLoadRequest, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: true
  });
});
commonData.on(actions.commonLoadSuccess, function (state, _ref2) {
  var _ref2$settings = _ref2.settings;
  _ref2$settings = _ref2$settings === void 0 ? {} : _ref2$settings;
  var _ref2$settings$custom = _ref2$settings.customFields,
      customFields = _ref2$settings$custom === void 0 ? initialState.customFields : _ref2$settings$custom,
      _ref2$settings$email_ = _ref2$settings.email_chars_limit,
      emailCharsLimit = _ref2$settings$email_ === void 0 ? initialState.emailCharsLimit : _ref2$settings$email_,
      _ref2$settings$printi = _ref2$settings.printing_fee_value,
      printingFeeValue = _ref2$settings$printi === void 0 ? initialState.printingFeeValue : _ref2$settings$printi,
      _ref2$settings$exchan = _ref2$settings.exchangeMarketplaceThreshold,
      exchangeMarketplaceThreshold = _ref2$settings$exchan === void 0 ? initialState.exchangeMarketplaceThreshold : _ref2$settings$exchan;
  return _objectSpread(_objectSpread({}, state), {}, {
    customFields,
    emailCharsLimit,
    printingFeeValue,
    exchangeMarketplaceThreshold,
    isLoaded: true,
    isLoading: false
  });
});
commonData.on(actions.commonLoadFail, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false
  });
});
commonData.on(actions.setCountries, function (state, _ref3) {
  var countries = _ref3.countries,
      usaStates = _ref3.usaStates;
  return _objectSpread(_objectSpread({}, state), {}, {
    countries,
    countriesMap: (0, _utils.objFromListWith)(R.prop('id'), countries),
    governments: fillGovernments(countries, usaStates)
  });
});
commonData.on(actions.setAvailableCountriesIds, function (state, ids) {
  return _objectSpread(_objectSpread({}, state), {}, {
    availableCountriesIds: ids
  });
});